const en = {
  // Navigation
  'nav.dashboard': 'Dashboard',
  'nav.students': 'Students',
  'nav.staff': 'Staff',
  'nav.generateChain': 'Generate Chain',
  'nav.classes': 'Classes',
  'nav.attendance': 'Attendance',
  'nav.qrCheckIn': 'QR Check-In',
  'nav.qrCodes': 'QR Codes',
  'nav.classroom': 'Classroom',
  'nav.taskAssignment': 'Task Assignment',
  'nav.myTasks': 'My Tasks',
  'nav.academicHub': 'Academic Hub',
  'nav.grades': 'Grades',
  'nav.reportCards': 'Report Cards',
  'nav.fees': 'Fees',
  'nav.feeStructure': 'Fee Structure',
  'nav.almanac': 'Almanac',
  'nav.announcements': 'Announcements',
  'nav.myPortal': 'My Portal',
  'nav.teachers': 'Teachers',
  'nav.documents': 'Documents',
  'nav.bin': 'Bin',
  'nav.expenses': 'Expenses',
  'nav.reports': 'Reports',
  'nav.logout': 'Logout',
  'nav.portal': 'Portal',

  // Common
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.add': 'Add',
  'common.search': 'Search',
  'common.filter': 'Filter',
  'common.export': 'Export',
  'common.import': 'Import',
  'common.download': 'Download',
  'common.upload': 'Upload',
  'common.loading': 'Loading...',
  'common.noData': 'No data found',
  'common.confirm': 'Confirm',
  'common.close': 'Close',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.submit': 'Submit',
  'common.update': 'Update',
  'common.actions': 'Actions',
  'common.status': 'Status',
  'common.type': 'Type',
  'common.date': 'Date',
  'common.amount': 'Amount',
  'common.description': 'Description',
  'common.name': 'Name',
  'common.email': 'Email',
  'common.phone': 'Phone',
  'common.address': 'Address',
  'common.notes': 'Notes',
  'common.optional': 'Optional',
  'common.required': 'Required',
  'common.all': 'All',
  'common.none': 'None',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.success': 'Success',
  'common.error': 'Error',
  'common.warning': 'Warning',
  'common.info': 'Info',
  'common.total': 'Total',
  'common.average': 'Average',
  'common.largest': 'Largest',
  'common.smallest': 'Smallest',
  'common.count': 'Count',
  'common.percentage': 'Percentage',
  'common.view': 'View',
  'common.list': 'List',
  'common.analytics': 'Analytics',
  'common.print': 'Print',
  'common.refresh': 'Refresh',
  'common.reset': 'Reset',
  'common.clear': 'Clear',
  'common.select': 'Select',
  'common.selected': 'Selected',
  'common.more': 'More',
  'common.less': 'Less',
  'common.today': 'Today',
  'common.thisWeek': 'This Week',
  'common.thisMonth': 'This Month',
  'common.thisYear': 'This Year',
  'common.allTime': 'All Time',
  'common.newest': 'Newest first',
  'common.oldest': 'Oldest first',
  'common.newestFirst': 'Newest first',
  'common.oldestFirst': 'Oldest first',
  'common.sortBy': 'Sort by',
  'common.sortByDate': 'Sort by Date',
  'common.sortByAmount': 'Sort by Amount',
  'common.sortByCategory': 'Sort by Category',
  'common.language': 'Language',
  'common.english': 'English',
  'common.turkish': 'Turkish',

  // Expenses
  'expenses.title': 'Expenses',
  'expenses.subtitle': 'Track and manage school expenses',
  'expenses.addNew': 'Add Expense',
  'expenses.edit': 'Edit Expense',
  'expenses.total': 'Total Expenses',
  'expenses.average': 'Average Expense',
  'expenses.categoriesUsed': 'Categories Used',
  'expenses.largest': 'Largest Expense',
  'expenses.perTransaction': 'per transaction',
  'expenses.differentCategories': 'different categories',
  'expenses.transactions': 'transactions',
  'expenses.noExpenses': 'No expenses found',
  'expenses.adjustFilters': 'Try adjusting your filters',
  'expenses.addFirst': 'Click "Add Expense" to record your first expense',
  'expenses.description': 'Description',
  'expenses.descriptionPlaceholder': 'e.g., Electricity bill for March',
  'expenses.amount': 'Amount (TZS)',
  'expenses.amountPlaceholder': 'e.g., 500000',
  'expenses.category': 'Category',
  'expenses.paymentMethod': 'Payment Method',
  'expenses.expenseDate': 'Expense Date',
  'expenses.vendor': 'Vendor/Payee',
  'expenses.vendorPlaceholder': 'e.g., TANESCO',
  'expenses.receiptImage': 'Receipt Image',
  'expenses.notes': 'Notes',
  'expenses.notesPlaceholder': 'Additional details...',
  'expenses.saveExpense': 'Save Expense',
  'expenses.updateExpense': 'Update Expense',
  'expenses.addNewTitle': 'Add New Expense',
  'expenses.editTitle': 'Edit Expense',
  'expenses.descriptionRequired': 'Description and amount are required',
  'expenses.validAmount': 'Please enter a valid amount',
  'expenses.addedSuccess': 'Expense added successfully',
  'expenses.updatedSuccess': 'Expense updated successfully',
  'expenses.deletedSuccess': 'Expense deleted',
  'expenses.savedLocally': 'Expense saved locally',
  'expenses.offlineMode': 'Expense saved locally (offline mode)',
  'expenses.deletedLocally': 'Expense deleted locally',
  'expenses.confirmDelete': 'Are you sure you want to delete this expense?',
  'expenses.exported': 'Exported',
  'expenses.noExport': 'No expenses to export',
  'expenses.categoryBreakdown': 'Category Breakdown',
  'expenses.monthlyTrends': 'Monthly Spending Trends',
  'expenses.paymentMethods': 'Payment Methods',
  'expenses.noCategoryData': 'No expense data yet',
  'expenses.noMonthlyData': 'No monthly data yet',
  'expenses.noPaymentData': 'No payment data yet',
  'expenses.addExpense': 'Add Expense',
  'expenses.addNewExpense': 'Add New Expense',
  'expenses.editExpense': 'Edit Expense',
  'expenses.noData': 'No expense data yet',
  'expenses.allCategories': 'All Categories',

  // Dashboard
  'dashboard.title': 'Dashboard',
  'dashboard.welcome': 'Welcome',
  'dashboard.totalStudents': 'Total Students',
  'dashboard.totalStaff': 'Total Staff',
  'dashboard.totalClasses': 'Total Classes',
  'dashboard.recentActivity': 'Recent Activity',
  'dashboard.quickActions': 'Quick Actions',

  // Students
  'students.title': 'Students',
  'students.addStudent': 'Add Student',
  'students.editStudent': 'Edit Student',
  'students.firstName': 'First Name',
  'students.lastName': 'Last Name',
  'students.gender': 'Gender',
  'students.grade': 'Grade',
  'students.class': 'Class',
  'students.parentName': 'Parent Name',
  'students.parentPhone': 'Parent Phone',
  'students.enrollmentDate': 'Enrollment Date',
  'students.totalStudents': 'Total Students',
  'students.male': 'Male',
  'students.female': 'Female',
  'students.searchPlaceholder': 'Search students...',

  // Staff
  'staff.title': 'Staff',
  'staff.addStaff': 'Add Staff',
  'staff.editStaff': 'Edit Staff',
  'staff.firstName': 'First Name',
  'staff.lastName': 'Last Name',
  'staff.role': 'Role',
  'staff.department': 'Department',
  'staff.phone': 'Phone',
  'staff.email': 'Email',
  'staff.salary': 'Salary',
  'staff.totalStaff': 'Total Staff',
  'staff.searchPlaceholder': 'Search staff...',

  // Classes
  'classes.title': 'Classes',
  'classes.addClass': 'Add Class',
  'classes.editClass': 'Edit Class',
  'classes.className': 'Class Name',
  'classes.grade': 'Grade',
  'classes.teacher': 'Teacher',
  'classes.studentCount': 'Students',
  'classes.totalClasses': 'Total Classes',
  'classes.searchPlaceholder': 'Search classes...',

  // Attendance
  'attendance.title': 'Attendance',
  'attendance.markAttendance': 'Mark Attendance',
  'attendance.date': 'Date',
  'attendance.class': 'Class',
  'attendance.present': 'Present',
  'attendance.absent': 'Absent',
  'attendance.late': 'Late',
  'attendance.excused': 'Excused',
  'attendance.rate': 'Attendance Rate',
  'attendance.totalPresent': 'Total Present',
  'attendance.totalAbsent': 'Total Absent',
  'attendance.searchPlaceholder': 'Search attendance...',

  // Grades
  'grades.title': 'Grades',
  'grades.addGrade': 'Add Grade',
  'grades.editGrade': 'Edit Grade',
  'grades.student': 'Student',
  'grades.subject': 'Subject',
  'grades.score': 'Score',
  'grades.grade': 'Grade',
  'grades.term': 'Term',
  'grades.exam': 'Exam',
  'grades.assignment': 'Assignment',
  'grades.average': 'Average',
  'grades.searchPlaceholder': 'Search grades...',

  // Fees
  'fees.title': 'Fees Management',
  'fees.addFee': 'Add Fee',
  'fees.editFee': 'Edit Fee',
  'fees.student': 'Student',
  'fees.amount': 'Amount',
  'fees.paid': 'Paid',
  'fees.pending': 'Pending',
  'fees.overdue': 'Overdue',
  'fees.totalCollected': 'Total Collected',
  'fees.totalPending': 'Total Pending',
  'fees.dueDate': 'Due Date',
  'fees.paymentDate': 'Payment Date',
  'fees.paymentMethod': 'Payment Method',
  'fees.receipt': 'Receipt',
  'fees.searchPlaceholder': 'Search fees...',

  // Reports
  'reports.title': 'Reports',
  'reports.generate': 'Generate Report',
  'reports.type': 'Report Type',
  'reports.dateRange': 'Date Range',
  'reports.studentReport': 'Student Report',
  'reports.financialReport': 'Financial Report',
  'reports.attendanceReport': 'Attendance Report',
  'reports.gradeReport': 'Grade Report',
  'reports.download': 'Download Report',

  // Almanac
  'almanac.title': 'Almanac',
  'almanac.addEvent': 'Add Event',
  'almanac.editEvent': 'Edit Event',
  'almanac.eventTitle': 'Event Title',
  'almanac.eventDate': 'Event Date',
  'almanac.eventType': 'Event Type',
  'almanac.description': 'Description',
  'almanac.holiday': 'Holiday',
  'almanac.exam': 'Exam',
  'almanac.meeting': 'Meeting',
  'almanac.activity': 'Activity',
  'almanac.searchPlaceholder': 'Search events...',

  // Documents
  'documents.title': 'Documents',
  'documents.upload': 'Upload Document',
  'documents.fileName': 'File Name',
  'documents.fileType': 'File Type',
  'documents.fileSize': 'File Size',
  'documents.uploadDate': 'Upload Date',
  'documents.uploadedBy': 'Uploaded By',
  'documents.category': 'Category',
  'documents.searchPlaceholder': 'Search documents...',

  // Bin
  'bin.title': 'Bin',
  'bin.restore': 'Restore',
  'bin.permanentDelete': 'Delete Permanently',
  'bin.empty': 'Bin is empty',
  'bin.restored': 'Item restored successfully',
  'bin.deleted': 'Item permanently deleted',
  'bin.searchPlaceholder': 'Search deleted items...',

  // Tasks
  'tasks.title': 'Task Assignment',
  'tasks.addTask': 'Add Task',
  'tasks.editTask': 'Edit Task',
  'tasks.title': 'Task Title',
  'tasks.description': 'Description',
  'tasks.assignedTo': 'Assigned To',
  'tasks.assignedBy': 'Assigned By',
  'tasks.dueDate': 'Due Date',
  'tasks.priority': 'Priority',
  'tasks.status': 'Status',
  'tasks.high': 'High',
  'tasks.medium': 'Medium',
  'tasks.low': 'Low',
  'tasks.pending': 'Pending',
  'tasks.inProgress': 'In Progress',
  'tasks.completed': 'Completed',
  'tasks.searchPlaceholder': 'Search tasks...',

  // My Tasks
  'myTasks.title': 'My Tasks',
  'myTasks.noTasks': 'No tasks assigned to you',
  'myTasks.markComplete': 'Mark as Complete',
  'myTasks.searchPlaceholder': 'Search your tasks...',

  // Academic Hub
  'academicHub.title': 'Academic Hub',
  'academicHub.lessonPlans': 'Lesson Plans',
  'academicHub.schemeOfWork': 'Scheme of Work',
  'academicHub.subjectEvaluation': 'Subject Evaluation',
  'academicHub.assessment': 'Assessment Forms',
  'academicHub.searchPlaceholder': 'Search academic resources...',

  // QR Attendance
  'qrAttendance.title': 'QR Check-In',
  'qrAttendance.scan': 'Scan QR Code',
  'qrAttendance.generate': 'Generate QR Code',
  'qrAttendance.studentName': 'Student Name',
  'qrAttendance.time': 'Check-In Time',
  'qrAttendance.date': 'Date',
  'qrAttendance.status': 'Status',
  'qrAttendance.verified': 'Verified',
  'qrAttendance.pending': 'Pending',

  // QR Management
  'qrManagement.title': 'QR Codes',
  'qrManagement.generate': 'Generate QR Codes',
  'qrManagement.print': 'Print QR Codes',
  'qrManagement.student': 'Student',
  'qrManagement.class': 'Class',
  'qrManagement.searchPlaceholder': 'Search QR codes...',

  // Fee Structure
  'feeStructure.title': 'Fee Structure',
  'feeStructure.addFee': 'Add Fee Item',
  'feeStructure.editFee': 'Edit Fee Item',
  'feeStructure.feeName': 'Fee Name',
  'feeStructure.amount': 'Amount',
  'feeStructure.grade': 'Grade',
  'feeStructure.term': 'Term',
  'feeStructure.dueDate': 'Due Date',
  'feeStructure.searchPlaceholder': 'Search fee structure...',

  // Announcements
  'announcements.title': 'Announcements',
  'announcements.add': 'Add Announcement',
  'announcements.edit': 'Edit Announcement',
  'announcements.title': 'Title',
  'announcements.content': 'Content',
  'announcements.audience': 'Audience',
  'announcements.everyone': 'Everyone',
  'announcements.staffOnly': 'Staff Only',
  'announcements.studentsOnly': 'Students Only',
  'announcements.date': 'Date',
  'announcements.searchPlaceholder': 'Search announcements...',

  // Classroom
  'classroom.title': 'Classroom',
  'classroom.addAssignment': 'Add Assignment',
  'classroom.submit': 'Submit Work',
  'classroom.grade': 'Grade',
  'classroom.feedback': 'Feedback',
  'classroom.dueDate': 'Due Date',
  'classroom.searchPlaceholder': 'Search classroom...',

  // Teachers
  'teachers.title': 'Teachers',
  'teachers.totalTeachers': 'Total Teachers',
  'teachers.subject': 'Subject',
  'teachers.qualification': 'Qualification',
  'teachers.searchPlaceholder': 'Search teachers...',

  // Student Portal
  'studentPortal.title': 'My Portal',
  'studentPortal.myGrades': 'My Grades',
  'studentPortal.myAttendance': 'My Attendance',
  'studentPortal.myFees': 'My Fees',
  'studentPortal.myTasks': 'My Tasks',
  'studentPortal.announcements': 'Announcements',
  'studentPortal.profile': 'My Profile',

  // Report Cards
  'reportCards.title': 'Report Cards',
  'reportCards.generate': 'Generate Report Cards',
  'reportCards.student': 'Student',
  'reportCards.grade': 'Grade',
  'reportCards.term': 'Term',
  'reportCards.subject': 'Subject',
  'reportCards.score': 'Score',
  'reportCards.average': 'Average',
  'reportCards.rank': 'Rank',
  'reportCards.searchPlaceholder': 'Search report cards...',

  // Chain Landing
  'chainLanding.title': 'School Portal',
  'chainLanding.login': 'Login',
  'chainLanding.chainInfo': 'Chain Information',

  // Login
  'login.title': 'Login',
  'login.accessCode': 'Access Code',
  'login.password': 'Password',
  'login.portal': 'Portal',
  'login.chain': 'Chain',
  'login.submit': 'Login',
  'login.error': 'Invalid credentials',
  'login.loggingIn': 'Logging in...',

  // Home
  'home.title': 'IHEZA School Management System',
  'home.subtitle': 'Comprehensive school management solution',
  'home.getStarted': 'Get Started',
  'home.learnMore': 'Learn More',

  // Generate Chain
  'generateChain.title': 'Generate Chain',
  'generateChain.chainName': 'Chain Name',
  'generateChain.chainCode': 'Chain Code',
  'generateChain.generate': 'Generate',
  'generateChain.success': 'Chain generated successfully',
  'generateChain.error': 'Failed to generate chain',

  // Subject Evaluation
  'subjectEvaluation.title': 'Subject Evaluation',
  'subjectEvaluation.subject': 'Subject',
  'subjectEvaluation.teacher': 'Teacher',
  'subjectEvaluation.grade': 'Grade',
  'subjectEvaluation.term': 'Term',
  'subjectEvaluation.score': 'Score',
  'subjectEvaluation.comments': 'Comments',
  'subjectEvaluation.searchPlaceholder': 'Search evaluations...',

  // Scheme of Work
  'schemeOfWork.title': 'Scheme of Work',
  'schemeOfWork.subject': 'Subject',
  'schemeOfWork.term': 'Term',
  'schemeOfWork.week': 'Week',
  'schemeOfWork.topic': 'Topic',
  'schemeOfWork.objectives': 'Objectives',
  'schemeOfWork.searchPlaceholder': 'Search scheme of work...',

  // Lesson Plan
  'lessonPlan.title': 'Lesson Plan',
  'lessonPlan.subject': 'Subject',
  'lessonPlan.topic': 'Topic',
  'lessonPlan.date': 'Date',
  'lessonPlan.duration': 'Duration',
  'lessonPlan.objectives': 'Objectives',
  'lessonPlan.materials': 'Materials',
  'lessonPlan.activities': 'Activities',
  'lessonPlan.assessment': 'Assessment',
  'lessonPlan.searchPlaceholder': 'Search lesson plans...',

  // Assessment Form
  'assessment.title': 'Assessment Forms',
  'assessment.student': 'Student',
  'assessment.subject': 'Subject',
  'assessment.type': 'Assessment Type',
  'assessment.score': 'Score',
  'assessment.total': 'Total Score',
  'assessment.date': 'Date',
  'assessment.comments': 'Comments',
  'assessment.searchPlaceholder': 'Search assessments...',

  // Chain Toggle
  'chainToggle.selectChain': 'Select Chain',
  'chainToggle.allChains': 'All Chains',
};

export default en;
